import { type FC } from 'react';
import ExpandableFilterPanel from 'components/molecules/expandable-filter-panel';
import { useActionTimeManagementFilters } from 'infrastructure/hooks/action-time-management/use-filter';

import Body from './body';
import s from './styles.module.scss';

const ActionTimeManagementFilters: FC = () => {
  const { count, resetFilter } = useActionTimeManagementFilters();
  return (
    <div className={s.wrapper}>
      <ExpandableFilterPanel filtersCount={count} onReset={resetFilter}>
        <Body />
      </ExpandableFilterPanel>
    </div>
  );
};

export default ActionTimeManagementFilters;
